export default "__VITE_ASSET__c63d3ad9__"